import { createContext, useContext } from 'react'
import { TransferMasterPayload } from '../../types/mf-execution.types'
import { OTPVerificationState, OTPVerificationHandlers } from '../../types/otp.types'

interface TransferContextType {
  transferMasterPayload: TransferMasterPayload
  handleTransferMasterPayload: (payload: TransferMasterPayload) => void
  isTransferOTPVerified: boolean
  handleTransferOTPVerification: (otp: string) => void
  otpVerificationState: OTPVerificationState
  otpVerificationHandlers: OTPVerificationHandlers
}

export const TransferContext = createContext<TransferContextType | undefined>(undefined)

export const useTransferContext = () => {
  const context = useContext(TransferContext)
  if (!context) {
    throw new Error('useTransferContext must be used within a TransferProvider')
  }
  return context
}
